// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"96c5e17b","693":"e27a989e","955":"8295b6d2"}[chunkId] + ".chunk.js";
};